export default "public/Frame_21_22.svg";